<!-- 查询计费接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructureForThirdPark"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
              "parkCode": "2KNROS88",
              "newCarCodeArray": [
                "粤EQ2673"
              ],
              "newCardCodeArray": [],
              "optType": 2,
              "traderCouponGrantSn": "9NAZE0P1O4333",
              "updateTime": 20191120000000
            },
            responseCode: {
              "data": {
              }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动请求第三方接入系统下发商家券变更信息到停车场",
                // flow: "/static/img/第三方车场商家券变更.png",
                sdkcondition: "cmd=updateTraderCouponForThi",
                httpcondition: this.commonUrls.third+"updateTraderCouponForThi",
                precondition: "无",
                fitSystem: "第三方停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'traderCouponGrantSn', info2: '是', info3: 'String', info4: '券编码' },
                        { info1: 'optType', info2: '是', info3: 'Integer', info4: '操作类型，0：标志券为未使用；1：标记券为已使用；2：标记券紧急回收；3: 变更车牌' },
                        { info1: 'updateTime', info2: '是', info3: 'String', info4: '格式：yyyyMMddHHmmss' },
                        { info1: 'newCarCodeArray', info2: '否', info3: 'String[]', info4: '新车牌数组， 当且仅当optType=3时生效' },
                        { info1: 'newCardCodeArray', info2: '否', info3: 'String[]', info4: '卡票号数组' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: []
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/common/updateTraderCouponForThi.vue